export enum DDTracerMode {
  Agent = 'agent',
}
